import React from 'react';

/** White shuttlecock mark only — drops the charcoal app-icon tile on navy bars. */
const ShuttlrBrandMark = ({ className = 'h-8 w-8' }) => (
  <img
    src="/latest_icon.png"
    alt=""
    className={`shrink-0 object-contain contrast-125 mix-blend-screen ${className}`}
    aria-hidden="true"
  />
);

export default ShuttlrBrandMark;
